import clsx from 'clsx';
import { forwardRef } from 'react';
import { LabelWithLinkMasking } from 'components';
import { Icon } from '@pixum/icon';
import Text, { TEXT_VARIANT } from '@pixum/text';
import type { ContactAreaProps } from './types';
import styles from './ContactArea.module.css';

export const ContactArea = forwardRef<HTMLDivElement, ContactAreaProps>(function ContactArea(
  {
    availability,
    title,
    subtitle,
    icon,
    href,
    className,
    masked,
    onClick,
    openLinkInNewTab = false,
  },
  ref,
) {
  return (
    <div ref={ref} className={clsx(styles.contactArea, className)}>
      <div
        className={styles.action}
        onClick={onClick}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick?.(e as unknown as React.MouseEvent<HTMLElement>);
          }
        }}
      >
        <div className={styles.headline}>
          <Icon name={icon} loading="lazy" alt="" />
          <Text variant={TEXT_VARIANT.OVERLINE}>{title}</Text>
        </div>
        <LabelWithLinkMasking
          href={href}
          text={subtitle}
          title={subtitle}
          variant={TEXT_VARIANT.SUBHEADLINE}
          target={openLinkInNewTab ? '_blank' : '_self'}
          rel={openLinkInNewTab ? 'noopener noreferrer' : undefined}
          masked={masked}
        />
      </div>
      {availability?.map((value, index) => (
        <Text className={styles.availability} key={`availability-${index}`} variant={TEXT_VARIANT.OVERLINE}>
          {value}
        </Text>
      ))}
    </div>
  );
});
